import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import './styles/base.css';
import './styles/layout.css';
import './styles/widgets.css';
import './styles/display.css';
import ErrorBoundary from './components/ErrorBoundary';
import AgentConstellation from './components/AgentConstellation';
import WorkstreamBoard from './components/WorkstreamBoard';
import PipelineDisplay from './components/PipelineDisplay';
import ScrumctlDisplay from './components/ScrumctlDisplay';
import BuildQueuePanel from './components/BuildQueuePanel';
import EvidencePanel from './components/EvidencePanel';
import TokenMonitor from './components/TokenMonitor';
import ActiveSessions from './components/ActiveSessions';
import SystemHealth from './components/SystemHealth';
import CronJobs from './components/CronJobs';
import AlertTicker from './components/AlertTicker';
import GitActivity from './components/GitActivity';

const panels = [
  AgentConstellation, WorkstreamBoard, PipelineDisplay,
  BuildQueuePanel, ScrumctlDisplay, EvidencePanel,
  TokenMonitor, ActiveSessions, SystemHealth,
  CronJobs, AlertTicker, GitActivity,
];

const DashboardApp = () => (
  <Provider store={store}>
    <div className="dashboard-shell" role="main">
      <header className="hero-console">
        <p className="eyebrow">OPENCLAW / AGENT OS</p>
        <h1>Agent Dashboard</h1>
        <div className="status-strip" aria-label="Console status">
          <span>CLAUDE: ORCHESTRATING</span>
          <span>SUBAGENTS: STAGED</span>
          <span>SCRUMCTL: READY</span>
          <span>SITES: INBOUND</span>
        </div>
      </header>
      <section className="ops-grid" aria-label="Ops dashboard panels">
        {panels.map((Panel, i) => (
          <ErrorBoundary key={"panel-" + i}>
            <Panel />
          </ErrorBoundary>
        ))}
      </section>
    </div>
  </Provider>
);

export default DashboardApp;
